<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <div class="view">
    <v-container class="pt-0 pb-0" fluid>
      <v-row>
        <v-col class="col-4 right-box" style="min-height: 600px">
          เป้ายอดขาย
          <hr/>
          <CreditBar :border="1"
                     :current="user_dashboard.commission_to_date"
                     :fontSize="14"
                     :height="24"
                     :max="$store.state.$user.target_sale"
                     :prop_blue="0"
                     :prop_green="user_dashboard.commission_to_date"
                     :prop_red="0"
                     :width="200"
                     class="mt-2"

          ></CreditBar>
          <v-sparkline
              :auto-line-width="true"
              :fill="false"
              :gradient="['#42b3f4']"
              :height="viewportToPixels('30vh')-100"
              :labels="graph_data.labels"
              :show-labels="true"
              :smooth="false"
              :value="graph_data.values"
              class="pt-2"
              label-size="12"
              type="bar"

          ></v-sparkline>

          <div style="clear: both"></div>
          <div class="mt-4">ค่าคอมมิชชั่น</div>

          <hr/>
          <v-simple-table class="overview-list" dense>
            <template v-slot:default>
              <tbody>
              <tr>
                <td>เดือน</td>
                <td class="text-right">ยอดขาย</td>
                <td class="text-right">ยอดหาร
                </td>
              </tr>
              <tr v-for="(item, index)  in internal_commission" :key="index">
                <td>{{ $helper.parseNoMonth(item.com_month) }}</td>
                <td :class="item.css" class="text-right">{{ $helper.number_format(item.total_so, 0) }} บาท</td>
                <td :class="item.css" class="text-right">{{ $helper.number_format(item.total_share, 0) }} บาท
                </td>

              </tr>
              </tbody>
            </template>
          </v-simple-table>

          <div class="mt-2">ค่าคอมนอก</div>
          <hr/>
          <v-simple-table class="overview-list" dense>
            <template v-slot:default>
              <tbody>
              <tr>
                <td>เดือน</td>
                <td class="text-right">ยอดรวม</td>
              </tr>
              <tr v-for="(item, index)  in external_commission" :key="index">
                <td>{{ $helper.parseNoMonth(item.com_month) }}</td>
                <td :class="item.css" class="text-right">{{ $helper.number_format(item.total_ex_discount, 0) }}
                  บาท
                </td>
              </tr>
              </tbody>
            </template>
          </v-simple-table>


        </v-col>

        <v-col>
          <div v-if="$store.state.$user.unread_notifications>0">
            แจ้งเตือน
            <hr/>
            <v-simple-table class="overview-list">
              <template v-slot:default>
                <tbody>
                <tr>
                  <td>วันที่</td>
                  <td>รายการ</td>
                  <td class="text-right">อ่านแล้ว
                  </td>
                </tr>
                <tr v-for="(item, index)  in unread_notification" :key="index">
                  <td>{{ $helper.date_format_short_with_time(item.created_at) }}</td>
                  <td :class="item.css">
                    <div v-if="item.type=='App\\Notifications\\DoStatusChanged'"
                         @click="item.data.id && $root.$emit('openOrder', {id:item.data.id,order:{id:item.data.id,code:item.data.code}})"
                    >
                      Order: {{ item.data.code }} ยกเลิก
                      {{ OrderConst.map(item.data.status_from) }} เป็น{{ OrderConst.map(item.data.status_to) }}
                    </div>
                    <div v-else-if="item.type=='App\\Notifications\\OrderApprove'"
                         @click="item.data.id && $root.$emit('openOrder', {id:item.data.id,order:{id:item.data.id,code:item.data.code}})"
                    >
                      Order: ลูกค้า {{ item.data.customer_code }} {{ item.data.customer_nickname }} รออนุมัติ
                    </div>
                    <div v-else>
                      {{ item.type }}
                    </div>
                  </td>
                  <td :class="item.css" class="text-right"
                      @click="Read(index,item)"
                  >
                    <v-btn v-if="item.read_at==='loading'" :loading="true" fab x-small>
                      <v-icon>mdi-checkbox-marked-circle</v-icon>
                    </v-btn>
                    <v-icon v-else-if="item.read_at==null"
                            :color="item.read_at?'green':''">mdi-checkbox-blank-circle-outline
                    </v-icon>
                    <v-icon v-else
                            :color="item.read_at?'green':''">mdi-checkbox-marked-circle-outline
                    </v-icon>
                  </td>
                </tr>
                </tbody>
              </template>
            </v-simple-table>

          </div>
          สรุปใบสั่งซื้อ
          <hr/>
          <v-simple-table class="overview-list">
            <template v-slot:default>
              <tbody>
              <tr>
                <td>เดือน-สถานะ</td>
                <td class="text-right">จำนวน</td>
                <td class="text-right">ยอดขาย</td>
                <td class="text-right">ยอดหาร
                </td>
              </tr>
              <tr v-for="(item, index)  in summary_so" :key="index"
                  @click="RedirectOrder({year_month:item.ym,status:item.status})">
                <td>{{ $helper.parseMonth(item.label) }}{{ item.status ? ' - ' + map(item.status) : '' }}</td>
                <td :class="item.css" class="text-right">{{ $helper.number_format(item.total_count, 0) }} ใบ</td>
                <td :class="item.css" class="text-right">{{ $helper.number_format(item.total_so, 0) }} บาท</td>
                <td :class="item.css" class="text-right">{{ $helper.number_format(item.total_share, 0) }} บาท
                </td>

              </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<style lang="scss" scoped>

.view {
  font-size: 18px;
}

.theme--light .right-box {
  background: lightgrey;
}

.theme--dark .right-box {
  background: #3c3c3c;
}

@media (min-height: 700px) {
  .right-box {
    min-height: 30vh;
  }
}

@media (min-height: 700px) {
  .right-box2 {
    min-height: 20vh;
  }
}


.right-col {
  padding-top: 0;
  padding-bottom: 0;
}

.right-container {
  padding: 0;
}

.bold {
  font-weight: bold;
}

.overview-list {
  background: transparent;

  td {
    padding: 0 8px;
  }
}
</style>
<script lang="ts">
import {OrderConst} from '@/models/Order'
import router from '@/router'
import {Component, Vue} from 'vue-property-decorator'
import CreditBar from '../components/Customer/CreditBar.vue'
import LoadingDummy from '../components/LoadingDummy.vue'
import Helper from '../services/Helper.js'

@Component({
  components: {LoadingDummy, CreditBar},
})
export default class ViewOverview extends Vue {
  customers_queue = [
    {time: '10:00', customer: 'Customer1'},
  ]
  user_dashboard = {
    commission_to_date: 0,
  }
  internal_commission = [
    {com_month: 'Loading', total_so: 0, total_share: 0},

  ]
  external_commission = [
    {com_month: 'Loading', total_ex_discount: 0},
  ]
  summary_so = [
    {label: 'Loading', ym: '2020-01', total_count: 'n/a', total_so: 'n/a', total_share: 'n/a'},
  ]
  notify_list = [
    {time: '10 เมย.', customer: 'Customer1', detail: 'โทรหาลูกค้า'},
  ]
  graph_data = {
    labels: [' '],
    values: [0],
  }
  memo = 'ทดสอบ บันทึกช่วยจำ'

  OrderConst = OrderConst
  unread_notification: any = []

  map(status) {
    return OrderConst.map(status)
  }

  viewportToPixels(value) {
    var parts = value.match(/([0-9\.]+)(vh|vw)/)
    var q = Number(parts[1])
    var side = window[['innerHeight', 'innerWidth'][['vh', 'vw'].indexOf(parts[2])]]
    return side * (q / 100)
  }

  async mounted() {
    const url = Helper.setting.overview.getListAPI

    try {
      const data = await Helper.get(url).then<{ data: any }>(({data}) => data)

      this.internal_commission = data.internal_commission
      this.external_commission = data.external_commission
      this.summary_so = data.summary_so
      this.graph_data = data.graph_data
      this.user_dashboard = data.user_dashboard

      console.log('graph_data', this.graph_data)
    } catch (e) {
      alert(e)
    }

    if (this.$store.state.$user.unread_notifications > 0) {
      Helper.get('/api/unread_notification').then<{ data: any }>(({data}) => {
        this.unread_notification = data.data.unread_notifications
      })
    }


  }

  async Read(index, item) {
    // debugger
    if (item.read_at) return
    item.read_at = 'loading'
    const url = '/api/read/' + item.id
    item = await Helper.post(url).then<{ data: any }>(({data}) => data.data)
    this.unread_notification[index] = item
    const backup = JSON.stringify(this.unread_notification)
    this.unread_notification = []
    this.unread_notification = JSON.parse(backup)
    this.$store.commit('notification_delta', -1)
  }

  RedirectOrder({year_month, status}) {
    console.log('RedirectOrder', [year_month, status])

    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    // let tmpDateFrom = (new Date(Date.now() - tzoffset))
    var tmpDateFrom = new Date(year_month + '-01')
    const dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)

    var lastDayOfMonth = new Date(tmpDateFrom.getFullYear(), tmpDateFrom.getMonth() + 1, 0)
    // tmpDateFrom.setDate(0)
    const dateTo = (new Date(lastDayOfMonth.getTime() - tzoffset)).toISOString().substr(0, 10)

    // console.log('RedirectOrder', [dateFrom, dateTo])

    router.push('/order/status/' + status + '/from/' + dateFrom + '/to/' + dateTo + '')
  }

}
</script>
